import React, { useEffect } from 'react';
import { ButtonComp } from 'atoms/Buttons';
import {
  getPaymentFailedButtonNavigation,
  redirectToCARTPage,
  redirectToAddHopePage,
  redirectToAddNewCard,
  redirectToGiftCardPage
} from 'common/utilities/utils';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import { resetOrderAction } from '@kfc-global/react-shared/redux/Actions/orderAction';
import { isAddHopePurchase, isGetGiftCardDetails, isGiftCardPurchase } from 'common/utilities/orderStatusUtils';
import { getPaymentFailedDisplayText, resetOrder } from 'components/paymentFailed/utils/paymentFailedUtils';
import PAYMENT_CONSTANTS from 'organisms/Payment/constants/PaymentConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const { PAYMENT_FAILED_SCREEN_TEXT } = PAYMENT_CONSTANTS;
export const isWicodeFailedErr = (isWicodeFinalisedFlag, isCardValidateFailedScreenData) => {
  return isWicodeFinalisedFlag ? (
    <div className='couponFailure'>{translateWithI18Next(TRANSLATE_MAPPING_KEY?.POST_ORDER_COUPON_FAILURE)}</div>
  ) : (
    getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.DESCRIPTION, isCardValidateFailedScreenData)
  );
};
const PaymentFailedView = props => {
  const { isCardValidateFailedScreen, location, dispatch, isWicodeFinaliseFailed } = props;
  const { isAddNewCard } = location;

  const getRedirectPage = () => {
    if(isAddHopePurchase()) {
      redirectToAddHopePage(props);
    } else if(isGiftCardPurchase() || isGetGiftCardDetails()){
      redirectToGiftCardPage(props, true)
    }
    else {
      isAddNewCard ? redirectToAddNewCard(props) : redirectToCARTPage(props, false, isWicodeFinaliseFailed);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    return () => {resetOrder(dispatch)}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className='PaymentFailedScreen au'>
      <div className='paymentFailed'>
        <div className='FailedDisplay'>
          <div className='Failimage'>
            <img src={IMAGE_PATH?.Issue} alt='issue img' />
          </div>
          {!isGiftCardPurchase() ? (
            <div className='notRight'>
              {getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.TITLE, isCardValidateFailedScreen)}
            </div>
          ) : (
            <div className='notRightGiftCard'>
              <div>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PAYMENT_NOT_SUCCESSFUL_HEADLINE_PART_ONE)}
              </div>
              <div>
                {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PAYMENT_NOT_SUCCESSFUL_HEADLINE_PART_TWO)}
              </div>
            </div>
          )}
          {!isGiftCardPurchase() ? (
            <div className='Reason col-sm-8 col-12'>
              {!isGetGiftCardDetails() &&
                isWicodeFailedErr(isWicodeFinaliseFailed, isCardValidateFailedScreen)}
            </div>
          ) : (
            <div className='ReasonGiftCard col-12'>
              {translateWithI18Next(TRANSLATE_MAPPING_KEY?.GIFT_CARD_PAYMENT_NOT_SUCCESSFUL_DESCRIPTION)}
            </div>
          )}

          <div className='backToCart'>
            <ButtonComp
              data-testid='Back-Cart-Button'
              className='button whiteButton blackBorder back-To-Cart'
              onClick={() => {
                props.dispatch(resetOrderAction());
                getRedirectPage();
              }}
            >
              {getPaymentFailedDisplayText(PAYMENT_FAILED_SCREEN_TEXT?.BUTTON_TEXT,isCardValidateFailedScreen)}
            </ButtonComp>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PaymentFailedView);
